<script setup lang="ts">
import { useRouter } from 'vue-router';

import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import VDialog from '@components/dialogs/VDialog/VDialog.vue';

import type { IModalPageWrapperEmits, IModalPageWrapperProps } from './types';

const { backTo, size = 'large', position = 'top' } = defineProps<IModalPageWrapperProps>();
const emit = defineEmits<IModalPageWrapperEmits>();

const router = useRouter();

function back(): void {
  if (backTo) {
    void router.push(backTo);
  }
}
</script>

<template>
  <VDialog
    :visible="showDialog"
    :title="modalTitle"
    :position="position"
    :size="size"
    @hide="emit('hide')"
    @after-hide="back"
  >
    <template #container>
      <div
        id="modal-scroll-container"
        class="overflow-y-auto rounded-xl"
      >
        <VIconButton
          icon="pi-times"
          severity="secondary"
          class="!absolute right-3 top-3 z-10"
          @click="emit('hide')"
        />
        <slot />
      </div>
    </template>
  </VDialog>
</template>
